<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-delete-all rounded-pill">
  <i class="bi bi-trash"></i>
    {{label}}
</button>
